import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/user-03.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M12.0001 15C15.6763 15 19.0076 16.554 21.4904 19.0674L21.7277 19.3145L21.7941 19.3916C22.1029 19.7936 22.0625 20.3723 21.6857 20.7275C21.309 21.0825 20.7299 21.0884 20.3468 20.7568L20.2726 20.6855L19.8576 20.2656C17.7411 18.2205 14.9917 17 12.0001 17C8.80904 17 5.89338 18.3886 3.72768 20.6855C3.34888 21.0873 2.71644 21.1062 2.31459 20.7275C1.91282 20.3487 1.89394 19.7163 2.2726 19.3145C4.77845 16.6567 8.20537 15 12.0001 15ZM15.5001 7.5C15.5001 5.567 13.9331 4 12.0001 4C10.0671 4 8.50014 5.567 8.50014 7.5C8.50014 9.433 10.0671 11 12.0001 11C13.9331 11 15.5001 9.433 15.5001 7.5ZM17.5001 7.5C17.5001 10.5376 15.0377 13 12.0001 13C8.96257 13 6.50014 10.5376 6.50014 7.5C6.50014 4.46243 8.96257 2 12.0001 2C15.0377 2 17.5001 4.46243 17.5001 7.5Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as User03Icon };
